import React from "react";
import AgentInboxesContent from "../content/AgentInboxContent.js";
import Layout from "../layout/Layout";

const AgentInboxes = () => {
  return (
    <Layout>
      <AgentInboxesContent />
    </Layout>
  );
};

export default AgentInboxes;
